import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import {
  Div,
  DragSortIcon,
  EditPenIcon,
  H5,
  Icon,
  P,
  TrashIconRed,
  lightTheme,
} from '@vgrubs/components';
import { CategoryV2Response } from 'components/src/types/menu.types';
import { CategorySchedulePills } from './CategorySchedulePills';

export const CategoryComponent = ({
  item,
  onClick,
  onClickDelete,
  isSorting,
  isPos,
}: {
  item: CategoryV2Response;
  onClick?: (item: CategoryV2Response) => void;
  onClickDelete?: (id: CategoryV2Response['id']) => void;
  isSorting: boolean;
  isPos: boolean;
}) => {
  const {
    setNodeRef,
    listeners,
    attributes,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: item.id,
  });

  const styles = {
    transform: CSS.Translate.toString(transform),
    transition,
    zIndex: isDragging ? 1000 : 0,
    opacity: isDragging ? 0.3 : 1,
    cursor: isSorting ? (isDragging ? 'grabbing' : 'grab') : 'pointer',
  };

  return (
    <Div
      ref={setNodeRef}
      style={styles}
      {...attributes}
      $box
      $p="12px 24px "
      $flex
      $alignCenter
      $between
      $mb="8"
      $width="100%"
      {...(isSorting ? listeners : {})}
      onClick={() => onClick?.(item)}
    >
      <Div $flex $gap="16px">
        {isSorting ? (
          <Icon>
            <DragSortIcon />
          </Icon>
        ) : null}

        <Div $width="100%">
          <H5 $m="0" $color={lightTheme.primary}>
            {item.name}
          </H5>
          {item.description && (
            <P $color={lightTheme.lightGray} $mb="0">
              {item.description}
            </P>
          )}
          <P $mb="0">
            {item.items.length} {item.items.length === 1 ? 'item' : 'items'}
          </P>
          <CategorySchedulePills schedules={item.schedules} />
        </Div>
      </Div>
      <Div $flex $alignCenter $between $gap="24px" $gapSM="12px">
        {!isPos && (
          <Icon $shadow $pointer>
            <EditPenIcon />
          </Icon>
        )}
        {!isPos && (
          <Icon
            $pointer
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClickDelete?.(item.id);
            }}
          >
            <TrashIconRed />
          </Icon>
        )}
        {/* <Icon>{item.paused ? <ResumeLogo /> : <PauseLogo />}</Icon> */}
      </Div>
    </Div>
  );
};
